module.exports = __webpack_public_path__ + "img/credit-card.a6939d16.svg";